import { Component, Input, OnInit } from '@angular/core';
import { MenuItemRoute, MenuItem, MenuItemIcon, MenuItemName } from '@enums/menu-item.enum';
// import { environment } from '@environments/environment';
import { AccountService } from '../services/account.service';
import { Role } from "@enums/role.enum";
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  styles: [`
  >>> app-sidenav {
    height: 100%;
  }
`]
})
export class SidenavComponent implements OnInit {
  environment = this.envConfigurationService.environment;

  @Input() isAuth: boolean = false;

  versionApp = this.environment.versionApp;

  MenuItemRoute = MenuItemRoute;
  MenuItem = MenuItem;
  MenuItemIcon = MenuItemIcon;
  MenuItemName = MenuItemName;

  menuList: MenuItem[];

  menuListDeclarationByRole: any[];
  menuListSupervisionByRole: any[];

  public userRole: Role | null;

  constructor(
    public accountService: AccountService,
    public envConfigurationService: EnvConfigurationService
  ) {
    this.menuListDeclarationByRole = [];
    this.menuListDeclarationByRole[Role.administrator] = [
      MenuItem.home,
      MenuItem.tonnage,
      MenuItem.toll,
      MenuItem.statements,
      MenuItem.users,
    ]
    this.menuListDeclarationByRole[Role.manager] = [
      MenuItem.home,
      MenuItem.tonnage,
      MenuItem.toll,
      MenuItem.statements,
      MenuItem.users,
    ]
    this.menuListDeclarationByRole[Role.user] = [
      MenuItem.home,
      MenuItem.tonnage,
      MenuItem.toll,
      MenuItem.statements,
      MenuItem.users,
    ]

    this.menuListSupervisionByRole = [];
    this.menuListSupervisionByRole[Role.administrator] = [
      MenuItem.home,
      MenuItem.tonnage,
      MenuItem.toll,
      MenuItem.statements,
      MenuItem.billing,
      MenuItem.customer,
      MenuItem.site,
      MenuItem.report,
      MenuItem.repository,
      MenuItem.users,
    ]
    this.menuListSupervisionByRole[Role.manager] = [
      MenuItem.home,
      MenuItem.tonnage,
      MenuItem.toll,
      MenuItem.statements,
      MenuItem.billing,
      MenuItem.customer,
      MenuItem.site,
      MenuItem.report,
      MenuItem.repository,
      MenuItem.users,
    ]
    this.menuListSupervisionByRole[Role.user] = [
      MenuItem.home,
      MenuItem.tonnage,
      MenuItem.toll,
      MenuItem.statements,
      MenuItem.customer,
      MenuItem.users,
    ]

  }

  ngOnInit() {
    this.initNavList();
    this.userRole = this.accountService.currentUser.value?.role_ || null;
    this.accountService.currentUser.subscribe(user => {
      this.userRole = user?.role_ != null ? user?.role_ : null;
      this.initNavList();
    })
  }

  private initNavList() {
    if (this.userRole != null) {
      switch (this.environment.application) {
        case 'declaration':
          this.menuList = this.menuListDeclarationByRole[this.userRole];
          // this.menuList = this.menuListDeclarationByRole[Role.administrator];
          break;
        case 'supervision':
          this.menuList = this.menuListSupervisionByRole[this.userRole];
          // this.menuList = this.menuListSupervisionByRole[Role.administrator];
          break;
      }
    }
  }
}
